import { RegisterRepository } from '@/Account/domain/RegisterRepository'
import { RegisterIdentifyModel } from '../domain/RegisterModel'
import { IndentifyForm, RegisterForm } from '@/Account/ui/hooks'
import { HttpModel } from '@/Shared/domain'
import { TokenResponseModel } from '../domain'
import { ValidateTokenResponse } from '../infrastructure/ApiRegisterRepository'

interface IRegister {
  verifyIdentity: (data: IndentifyForm) => Promise<HttpModel<RegisterIdentifyModel>>
  resendEmail: (data: IndentifyForm) => Promise<HttpModel<string>>
  createAccount: (data: RegisterForm, token?: string) => Promise<HttpModel<TokenResponseModel>>
  validateToken:(token: string) => Promise<HttpModel<ValidateTokenResponse>>
}

export const RegisterContract = (RegisterRepository: RegisterRepository): IRegister => ({
  verifyIdentity: async (data: IndentifyForm): Promise<HttpModel<RegisterIdentifyModel>> =>
    await RegisterRepository.VerifyIdentity(data),
  resendEmail: async (data: IndentifyForm): Promise<HttpModel<string>> =>
      await RegisterRepository.ResendEmail(data),
  createAccount: async (data: RegisterForm, token?: string): Promise<HttpModel<TokenResponseModel>> =>
    await RegisterRepository.CreateAccount(data, token),
  validateToken: async (token: string): Promise<HttpModel<ValidateTokenResponse>> =>
    await RegisterRepository.ValidateToken(token)
})
